import type { PropsWithChildren, FunctionComponent } from 'react'
import { cloneElement, useMemo, useEffect } from 'react'
import { usePendingPartnerOnboardingRedirection } from '@retailer-platform/domain-onboarding'
import { RouteSuspense } from '../../../legacy/dash-components/route-suspense/RouteSuspense'
import { useCoreContext } from '../../../utils/core/RPPCoreContext'
import { DashSwitch } from '../../../exports/routing'
import { reportBootTiming } from '../../../utils/performance/bootTiming'

export const PartnerScopedRoutes: FunctionComponent<PropsWithChildren<unknown>> = () => {
  const coreContext = useCoreContext()

  const scopedRouters = useMemo(
    () => coreContext.partnerScopedRouters.map(el => cloneElement(el, { key: el.props.route })),
    [coreContext]
  )

  const { loading } = usePendingPartnerOnboardingRedirection()

  // Track framework boot time when partner-scoped routes are ready
  useEffect(() => {
    reportBootTiming('framework_boot_time_partner_scoped_v2')
  }, [])

  if (loading) {
    return null
  }

  return (
    <RouteSuspense>
      <DashSwitch>{scopedRouters}</DashSwitch>
    </RouteSuspense>
  )
}
